// LICENSE : MIT
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.default = suitClassNames;

var _object = require("object.assign");

var _object2 = _interopRequireDefault(_object);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Allowed keyword list
var ALLOW_KEY_NAMES = ["namespace", "descendant", "component", "modifiers", "states", "utilities"];
var DefaultSuitCSSObject = {
    namespace: "", // class="namespace-Component"
    descendant: "", // class="Component-descendant"
    component: "", // class="Component"
    modifiers: [], // class="Component--modifier"
    states: [], // class="Component is-state"
    utilities: [] // class="u-utility Component"
};
/**
 * @param {Object} object
 */
var validateSuitCSSObject = function validateSuitCSSObject(object) {
    var keys = Object.keys(object);
    keys.forEach(function (key) {
        if (ALLOW_KEY_NAMES.indexOf(key) === -1) {
            throw new Error("suitcss-classnames don't allowed the key name:\"" + key + "\"\nYou can use one of \"" + ALLOW_KEY_NAMES.join('", "') + "\" as a key name.\n");
        }
    });
};
/**
 * Create class names string from object.
 * The option object should have `component` property.
 * It it based name of the class names.
 * @param {{
 * namespace: ?string, descendant: ?string, component: string,
 * modifiers: (?string[] | ?Object), states: (?string[] | ?Object), utilities: (?string[] | ?Object)
 * }} suitCSSObject
 * @returns {string} class names string. it could be assigned to `class` attribute of element.
 */
function suitClassNames(suitCSSObject) {
    if (suitCSSObject == null) {
        throw new Error("require options object.");
    }
    if (suitCSSObject.component == null) {
        throw new Error("require \"component\" option value.\nPlease specify \"component\" value.\n\nsuitClassNames({\n    component: \"ComponentName\"\n});\n");
    }
    validateSuitCSSObject(suitCSSObject);
    var suitCSS = (0, _object2.default)({}, DefaultSuitCSSObject, suitCSSObject);
    var namespace = suitCSS.namespace;
    var descendant = suitCSS.descendant;
    var component = suitCSS.component;
    var modifiers = suitCSS.modifiers;
    var states = suitCSS.states;
    var utilities = suitCSS.utilities;

    var base = (namespace ? namespace + "-" : "") + component + (descendant ? "-" + descendant : "");

    var addPrefix = function addPrefix(prefix, key) {
        var index = key.indexOf(prefix);
        // if don't contain prefix, add prefix
        if (index === -1) {
            return prefix + key;
        } else if (index === 0) {
            // if key start with prefix, don't add prefix
            return key;
        } else {
            // if key has prefix, but it is not prefix, add prefix
            return prefix + key;
        }
    };
    var map = function map(args, prefix) {
        if (!args) {
            return false;
        }
        /*
            {
                "stateA": true,
                "stateB": false
            }
            =>
            {
                "is-stateA": true
            }
         */
        if (!Array.isArray(args) && (typeof args === "undefined" ? "undefined" : _typeof(args)) === "object") {
            return Object.keys(args).reduce(function (result, key) {
                var prefixedKey = addPrefix(prefix, key);
                result[prefixedKey] = args[key];
                return result;
            }, {});
        }
        var array = Array.isArray(args) ? args : [args];
        return array.map(function (key) {
            return addPrefix(prefix, key);
        });
    };

    var classNamesMap = [map(utilities, "u-"), base, map(modifiers, base + "--"), map(states, "is-")].filter(function (classMap) {
        return classMap !== false;
    });
    return (0, _classnames2.default)(classNamesMap).trim();
}
module.exports = exports['default'];
//# sourceMappingURL=suitcss-classnames.js.map


//////////////////
// WEBPACK FOOTER
// ./~/suitcss-classnames/lib/suitcss-classnames.js
// module id = 34
// module chunks = 0